<template>
  <div class="betaling-page">
    <section class="betaling-card">
      <div class="betaling-icon">
        <i class="pi pi-check-circle"></i>
      </div>
      <h1 class="betaling-title">Bedankt voor uw betaling</h1>
      <p class="betaling-description">
        Uw betaling is bij ons betaalprovider afgerond. De verwerking kan een moment duren; zodra de betaling binnen is
        werken wij de factuur automatisch bij en ontvangt u bericht per e-mail.
      </p>
      <p class="betaling-note">U kunt deze pagina sluiten.</p>

      <div class="betaling-actions">
        <Button label="Naar het portaal" icon="pi pi-home" @click="naarPortaal" />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
  /**
   * Landingspagina na een betaling bij de betaalprovider (Mollie redirectUrl).
   *
   * Bewust publiek en bewust statisch: de betaler heeft hier geen portaalsessie
   * en de pagina mag geen factuurgegevens tonen aan iedereen die de URL heeft.
   * De statusverwerking loopt volledig via de webhook, niet via deze redirect —
   * die kan de gebruiker immers ook wegklikken.
   */
  import { useRouter } from "vue-router";
  import Button from "primevue/button";

  const router = useRouter();

  const naarPortaal = () => {
    void router.push("/");
  };
</script>

<style scoped>
  .betaling-page {
    display: flex;
    justify-content: center;
    padding: 3rem 1rem;
  }

  .betaling-card {
    border-radius: 0.75rem;
    border: 1px solid var(--p-background-200);
    background: linear-gradient(145deg, var(--p-background-0), var(--p-background-50));
    padding: 2.5rem;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
    max-width: 36rem;
    text-align: center;
  }

  .betaling-icon {
    font-size: 3rem;
    line-height: 1;
    color: var(--p-green-500, #22c55e);
  }

  .betaling-title {
    margin: 1rem 0 0;
    font-size: 1.75rem;
    font-weight: 700;
    color: var(--p-background-900);
  }

  .betaling-description {
    margin: 1rem 0 0;
    line-height: 1.7;
    color: var(--p-background-700);
  }

  .betaling-note {
    margin: 0.75rem 0 0;
    font-size: 0.875rem;
    color: var(--p-background-500);
  }

  .betaling-actions {
    margin-top: 1.75rem;
    display: flex;
    justify-content: center;
  }
</style>
